//Helper functions for determining when to show regulations.gov content for Advocacy forms targeting regulations.gov.

export function shouldShowRegulationsGovContent(formDef) {
  if (!formDef) {
    return false;
  }
  
  var isAdvocacyType = formDef.type === 'AdvocacyForm';
  var isRegulationsGovTarget = !!formDef.documentId;
  
  return isAdvocacyType && isRegulationsGovTarget;
}

export function buildRegulationsGovContext(formDef) {
  if (!formDef || !formDef.documentId) {
    return {
      shouldShowRegulationsGovButtons: false,
      regulationsGovUrl: null,
      regulationsGovUrlLabel: null,
      regulationsGovDocId: null,
      regulationsGovCommentUrl: null
    };
  }
  
  return {
    shouldShowRegulationsGovButtons: shouldShowRegulationsGovContent(formDef),
    regulationsGovUrl: 'https://www.regulations.gov/document/' + formDef.documentId,
    regulationsGovUrlLabel: 'View this document on Regulations gov',
    regulationsGovDocId: formDef.documentId,
    regulationsGovCommentUrl: 'https://www.regulations.gov/commenton/' + formDef.documentId
  };
}

export function copyToClipboard(text) {
  if (navigator.clipboard && window.isSecureContext) {
    return navigator.clipboard.writeText(text)
      .then(function() {
        return true;
      })
      .catch(function() {
        return fallbackCopyToClipboard(text);
      });
  } else {
    return Promise.resolve(fallbackCopyToClipboard(text));
  }
}

// Some browsers before 2018 may not support the clipboard API, so we use this fallback.
function fallbackCopyToClipboard(text) {
  var textArea = document.createElement('textarea');
  textArea.value = text;
  textArea.style.position = 'fixed';
  textArea.style.left = '-999999px';
  textArea.style.top = (window.pageYOffset || document.documentElement.scrollTop) + 'px';
  textArea.setAttribute('readonly', '');
  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();
  
  try {
    var successful = document.execCommand('copy');
    document.body.removeChild(textArea);
    return successful;
  } catch (err) {
    document.body.removeChild(textArea);
    return false;
  }
}

export function handleCopyButtonClick(textToCopy, copyButton, restoreText) {
  copyToClipboard(textToCopy).then(function(success) {
    if (success) {
      copyButton.text('Copied!');
      setTimeout(function() {
        copyButton.text(restoreText);
      }, 2000);
    } else {
      copyButton.text('Copy Failed');
      setTimeout(function() {
        copyButton.text(restoreText);
      }, 2000);
    }
  }).catch(function() {
    copyButton.text('Copy Failed');
    setTimeout(function() {
      copyButton.text(restoreText);
    }, 2000);
  });
}
